/**
 * Simple timer utility for measuring latency in telemetry events.
 */
const timers = new Map<string, number>();

export const startTimer = (key: string) => timers.set(key, Date.now());

export const endTimer = (key: string): number => {
  const start = timers.get(key);
  if (!start) return 0;
  timers.delete(key);
  return Date.now() - start;
};
